import { logger } from '@packages/utilities';
import type { Promotion } from '../../types';

export const fetchAndActivatePromotion = async (
  promotionCode: string,
  setVoucher: (promotionData: Promotion) => void,
) => {
  fetch(`/api/promotions/promotion/${promotionCode}`)
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error(response.statusText);
    })
    .then((promotionData: Promotion) => {
      if (promotionData) {
        setVoucher(promotionData);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        throw new Error(`no promotion data for promotionCode ${promotionCode}`);
      }
    })
    .catch((error) => {
      logger.error(error, 'set remote promotion error');
    });
};
